/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Green_Gadfly_CookInputs */

const en_new_green_gadfly_cook = /** @type {(inputs: New_Green_Gadfly_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const de_new_green_gadfly_cook = /** @type {(inputs: New_Green_Gadfly_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilfe`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {New_Green_Gadfly_CookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const new_green_gadfly_cook = /** @type {((inputs?: New_Green_Gadfly_CookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Green_Gadfly_CookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_green_gadfly_cook(inputs)
	return de_new_green_gadfly_cook(inputs)
});